import { FeatureFlagService } from '../services/feature-flag.service';
import { FeatureFlagsEnum } from '../enums';
import { AppInjector } from '../../app.injector';

export function IsFeatureFlagEnabled(flagKey: FeatureFlagsEnum | string): Function {
    return function (target: Record<string, unknown>, propertyKey: string): void {
        const resolvingInstances: WeakSet<object> = new WeakSet<object>();
        Object.defineProperty(target, propertyKey, {
            configurable: true,
            get(this: Record<string, unknown>) {
                if (resolvingInstances.has(this as object)) {
                    return undefined;
                }
                if (Object.prototype.hasOwnProperty.call(this, propertyKey)) {
                    return Object.getOwnPropertyDescriptor(this, propertyKey)?.value;
                }
                resolvingInstances.add(this as object);
                const featureFlagServiceInstance: FeatureFlagService =
                    AppInjector.get().get(FeatureFlagService);
                const value = featureFlagServiceInstance?.getFlag(flagKey);
                Object.defineProperty(this, propertyKey, {
                    value,
                    configurable: true,
                });
                resolvingInstances.delete(this as object);
                return value;
            },
        });
    };
}
